const styles = {
  container: {
    stroke: 'text',
    width: 'auto',
    p: 2,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    backgroundColor: 'backgroundSecondary',
    borderRadius: 'buttonBig',
    cursor: 'pointer',
    minWidth: 'unset',
    transition: 'all .2s',
    '& svg': {
      minWidth: 18,
      height: 18,
      margin: 0
    },
    '&:hover': {
      backgroundColor: 'backgroundSecondaryHover'
    }
  }
}

export default styles
